module.exports = __webpack_public_path__ + "img/2796ed81999693.5d10c0872415e.e4b6323e.gif";